import {
  TableContainer,
  Paper,
  Table,
  TableRow as MUIRow,
  TableHead,
  TableBody,
  Button,
  makeStyles,
} from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { useRecoilState, useSetRecoilState, useRecoilValue } from "recoil";
import { StyledTableCell } from "../../MaterialTheme/themes";
import { IOmniumType, IRecordType3, PopupType } from "../../Models/Entities";
import { BASE_URL, extractId, fetcher, sendData } from "../../Models/Fetcher";
import {
  refreshTables,
  popupState,
  sortingState,
  toastState,
} from "../../Store/atoms";
import Loading from "../Utilities/Loading";
import AddIcon from "@material-ui/icons/Add";
import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from "@material-ui/icons/Edit";
import TableRowType3 from "./TableRowType3";
import TableHeaderType3 from "./TableHeaderType3";
import { sortRecords } from "../../Utilities/sortFunctions";

interface IRecordsTableProps {
  type: IOmniumType;
  locked: boolean;
}

const useStyles = makeStyles({
  table: {
    minWidth: 700,
  },
  trashIcon: {
    transition: "500ms",
    "&:hover": {
      cursor: "pointer",
      color: "#dc3545",
    },
  },
  editIcon: {
    transition: "500ms",
    "&:hover": {
      cursor: "pointer",
      color: "#da7422",
    },
  },
});

export default ({ type, locked }: IRecordsTableProps) => {
  const location = useLocation();
  const classes = useStyles();
  const tableId = extractId(location.pathname);
  const [refreshType, setRefreshType] = useRecoilState(refreshTables);
  const setPopup = useSetRecoilState(popupState);
  const [data, setData] = useState<IRecordType3[] | null>(null);
  const sortType = useRecoilValue(sortingState);
  const setDisplayToast = useSetRecoilState(toastState);

  useEffect(() => {
    const url =
      BASE_URL +
      "codetables/" +
      tableId.toString() +
      "/records-3?type=" +
      type.id.toString();

    setRefreshType(-1);
    fetcher(url).then((res) => {
      setData(res.data);
    });
  }, [refreshType]);

  if (!data) {
    return <Loading />;
  }

  if (data === null) {
    return <Loading />;
  }

  const handleDeleteType = async () => {
    const typeId = type.id;
    const response = await sendData(
      `${BASE_URL}codetables/${tableId}/type3/${typeId}`,
      "DELETE",
      []
    );

    if (response.status !== 200) {
      setDisplayToast({
        open: true,
        severity: "error",
        message: response.data.message,
      });
    } else {
      setDisplayToast({
        open: true,
        severity: "success",
        message: response.data.message,
      });
      window.location.reload();
    }
  };

  const handleEditType = async () => {
    const editTypeProps = { type: type, typeNumber: 3 };
    setPopup({ type: PopupType.EditType, props: editTypeProps });
  };

  const addRecord = (e: any) => {
    setPopup({ type: PopupType.AddRecord, props: type });
  };

  const styles = { width: "100%" };

  sortRecords(sortType.column, sortType.ascending, data);

  return (
    <div
      style={{ display: "flex", flexDirection: "column", alignItems: "center" }}
    >
      <TableContainer component={Paper}>
        <Table className={classes.table} aria-label="customized table">
          <TableHead>
            <MUIRow style={styles} className="header-row">
              <StyledTableCell>{type.name}</StyledTableCell>
              <StyledTableCell />
              <StyledTableCell />
              <StyledTableCell />
              <StyledTableCell />
              <StyledTableCell>
                <EditIcon
                  className={classes.editIcon}
                  onClick={handleEditType}
                />
              </StyledTableCell>
              <StyledTableCell>
                <DeleteIcon
                  className={classes.trashIcon}
                  onClick={handleDeleteType}
                />
              </StyledTableCell>
            </MUIRow>
          </TableHead>
          <TableHeaderType3 />
          <TableBody>
            {data.map((row) => (
              <TableRowType3 locked={locked} key={row.id} {...row} />
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      {data.length === 0 && (
        <Button
          style={{ width: "20%", margin: "1rem auto" }}
          color="primary"
          variant="contained"
          onClick={addRecord}
        >
          <AddIcon />
        </Button>
      )}
    </div>
  );
};
